module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_NB2-p65_Dec1958.06ffa53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_NB2-p65_Dec1958.jpg
// module id = lDpJ
// module chunks = 0